import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';

Vue.use(VueAxios, axios);

const state = {
  currentEvent: null,
  totalApprovedEvents: 0,
  listApprovedEvent: [],
  listEvent: [],
  listSingleEvent: [],
  listEventGroup: [],
  sort: {
    type: 'dateTime',
    reverse: false
  },
  countTotalEvent: [],
  countClientEvent: [],
  userId: 0,
  expandId: -1,
  listEventStatus: [],
  indexOfItemModifying: -1,
  listEventRelated: [],
  relatedItemInfo: [], // array info status & count event in status
  showRelatedEvents: false,
  listBackup: [],
  columnWidth: {
    eventName: {
      pre: null,
      next: 'prefDate',
      size: 0,
      show: true
    },
    prefDate: {
      pre: 'eventName',
      next: 'projPart',
      size: 0,
      show: true
    },
    projPart: {
      pre: 'prefDate',
      next: 'fullAddress',
      size: 0,
      show: true
    },
    fullAddress: {
      pre: 'projPart',
      next: 'building',
      size: 0,
      show: true
    },
    building: {
      pre: 'fullAddress',
      next: 'eventLocation',
      size: 0,
      show: true
    },
    eventLocation: {
      pre: 'building',
      next: 'startTime',
      size: 0,
      show: true
    },
    startTime: {
      pre: 'eventLocation',
      next: 'duration',
      size: 0,
      show: true
    },
    duration: {
      pre: 'startTime',
      next: 'endTime',
      size: 0,
      show: true
    },
    endTime: {
      pre: 'duration',
      next: 'timeZone',
      size: 0,
      show: true
    },
    timeZone: {
      pre: 'endTime',
      next: 'contactName',
      size: 0,
      show: true
    },
    contactName: {
      pre: 'timeZone',
      next: 'action',
      size: 0,
      show: true
    },
    action: {
      pre: 'contactName',
      next: null,
      size: 0,
      show: true
    }
  },
  listOnSiteContact: [],
  flagCreateEvent: false,
  submitAllEventSuccess: true,
  messageError: '',
  lockIds: {
    eventIds: [],
    userIds: []
  },
  errorCodes: null,
  isLoading: false,
  histories: [],
  columnTableUserWidth: {
    firstName: {
      pre: null,
      next: 'lastName',
      size: 0,
      show: true
    },
    lastName: {
      pre: 'firstName',
      next: 'email',
      size: 0,
      show: true
    },
    email: {
      pre: 'lastName',
      next: 'phone',
      size: 0,
      show: true
    },
    phone: {
      pre: 'email',
      next: 'clientAccount',
      size: 0,
      show: true
    },
    clientAccount: {
      pre: 'email',
      next: 'role',
      size: 0,
      show: true
    },
    role: {
      pre: 'clientAccount',
      next: 'payRates',
      size: 0,
      show: true
    },
    status: {
      pre: 'role',
      next: 'payRates',
      size: 0,
      show: true
    },
    payRates: {
      pre: 'status',
      next: 'address',
      size: 0,
      show: true
    },
    address: {
      pre: 'payRates',
      next: 'action',
      size: 0,
      show: true
    },
    action: {
      pre: 'role',
      next: null,
      size: 0,
      show: true
    }
  },
  columnTableStaffingWidth: {
    firstName: {
      pre: null,
      next: 'lastName',
      size: 0,
      show: true
    },
    lastName: {
      pre: 'firstName',
      next: 'email',
      size: 0,
      show: true
    },
    email: {
      pre: 'lastName',
      next: 'phoneNumber',
      size: 0,
      show: true
    },
    phoneNumber: {
      pre: 'email',
      next: 'role',
      size: 0,
      show: true
    },
    role: {
      pre: 'phoneNumber',
      next: 'payRates',
      size: 0,
      show: true
    },
    events: {
      pre: 'role',
      next: 'actions',
      size: 0,
      show: true
    },
    payRates: {
      pre: 'events',
      next: 'address',
      size: 0,
      show: true
    },
    address: {
      pre: 'payRates',
      next: 'events',
      size: 0,
      show: true
    },
    actions: {
      pre: 'events',
      next: null,
      size: 0,
      show: true
    }
  },
  isUpdating: false,
  isLoadingModal: false,
  isLoadingParticipant: false,
  listApprovedEventBackup: [],
  datesHasData: [],
  lockedDates: [],
  dateRangeHasData: [],
  eventDetailId: 0,
  eventDetailChangeOrder: {},
  eventDetailHistory: [],
  isLoadingEventDetailHistory: true,
  staffList: [
  ],
  staffLead: [],
  staffScreener: [],
  staffConcierge: [],
  openEventStaffModal: '',
  staffDetail: [], // This is used to stored staff detail when open the modal. Purpose: when navigating from event detail to staff modal
  manageEventReports: [],
  sliderValue: {
    begin: '0',
    end: '0'
  },
  keywordSearchEvent: '',
  colTableEmailHistories: {
    sentDate: {
      pre: null,
      next: 'emailTemplate',
      size: 0,
      show: true
    },
    emailTemplate: {
      pre: 'sentDate',
      next: 'relatedEvent',
      size: 0,
      show: true
    },
    relatedEvent: {
      pre: 'emailTemplate',
      next: 'recipients',
      size: 0,
      show: true
    },
    recipients: {
      pre: 'relatedEvent',
      next: 'actions',
      size: 0,
      show: true
    },
    actions: {
      pre: 'recipients',
      next: null,
      size: 0,
      show: true
    }
  },
  zIndex: 999,
  isDownloading: false
};

export default state



// WEBPACK FOOTER //
// ./src/store/modules/events/states.js